import { render, staticRenderFns } from "./ResultsMainFilter.vue?vue&type=template&id=37b6220d"
import script from "./ResultsMainFilter.vue?vue&type=script&lang=js"
export * from "./ResultsMainFilter.vue?vue&type=script&lang=js"
import style0 from "./ResultsMainFilter.vue?vue&type=style&index=0&id=37b6220d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports